import { Brand } from "@App/types";
import { Brands } from "@App/types/enums";

export const BrandIs = (brandId: Brands, brand: Brand | null) => {
  return brand?.id === brandId;
};
